const HEX_RADIX = 16;
const HEX_PAD_TAIL = -2;
const HASH_SHIFT_BITS = 16;
const HASH_SEED = 280;
const RED_MASK = 0xff0000;
const GREEN_MASK = 0x00ff00;
const BLUE_MASK = 0x0000ff;
const RED_SHIFT = 16;
const GREEN_SHIFT = 8;

export const hashStringToColor = (value?: string | number) => {
  if (!value) return "";

  const str = value.toString();

  const color = (v: number) => `0${v.toString(HEX_RADIX)}`.slice(HEX_PAD_TAIL);

  let hash = HASH_SEED;

  for (let index = 0; index < str.length; index++) {
    hash = (hash << HASH_SHIFT_BITS) + hash + str.charCodeAt(index);
  }

  const r = color((hash & RED_MASK) >> RED_SHIFT);
  const g = color((hash & GREEN_MASK) >> GREEN_SHIFT);
  const b = color(hash & BLUE_MASK);

  return `#${r}${g}${b}`;
};
